import React from 'react';
import { appColors } from '../theme/colors';

const Logo: React.FC = () => {
  return (
    <svg fill="none" height="40" viewBox="0 0 24 24" width="40" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke={appColors.primary} strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"></path>
      <path d="M2 17L12 22L22 17" stroke={appColors.primary} strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"></path>
      <path d="M2 12L12 17L22 12" stroke={appColors.primary} strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"></path>
    </svg>
  );
};

export default Logo;
